import React from 'react';
import './step-nav.less';

/**
 * 步骤导航
 * @param step 现在到第几步了
 * @returns {*}
 * @constructor
 */
export default function StepNav({step = 1}) {
    // 每个步骤有3中状态，没有到这一步骤时，使用默认的class。
    // 是当前步骤时添加ci-step-current
    // 切换到下一步添加ci-step-pass
    // 中间的分割线有经过和没有经过两种状态，class分别是默认和ci-step-divide-active

    // 第1步  #step1 class="ci-step-current"
    // 第2步  #step1 class="ci-step-pass"
    //       #step2 class="ci-step-current"
    // 第3步  #step1 class="ci-step-pass"
    //       #step2 class="ci-step-pass"
    //       #step3 class="ci-step-current"
    let step1Cls = 'ci-step-current',
        step2Cls = '',
        step3Cls = '';
    if (step === 2) {
        step1Cls = 'ci-step-pass';
        step2Cls = 'ci-step-current';
    } else if (step === 3) {
        step1Cls = 'ci-step-pass';
        step2Cls = 'ci-step-pass';
        step3Cls = 'ci-step-current';
    }
    return (
        <div>
            <div className="ci-step">
                <div id="step1" className={step1Cls}>1</div>
                <div className={'ci-step-divide ' + (step > 1 ? 'ci-step-divide-active' : '')}/>
                <div id="step2" className={step2Cls}> 2</div>
                <div className={'ci-step-divide ' + (step > 2 ? 'ci-step-divide-active' : '')}/>
                <div id="step3" className={step3Cls}>
                    <img src={require('../../../images/host/icon-ok.png')}/>
                </div>
            </div>
            <div className="ci-step-desc text-center">
                <div style={{display: step === 1 ? 'block' : 'none'}}>
                    {UG.lang.template('Step 1: Pick gifts for your new gift dashboard first.')}
                </div>
                <div style={{display: step === 2 ? 'block' : 'none'}}>
                    {UG.lang.template('Step 2: Copy your new gift dashboard’s link.')}
                </div>
                <div style={{display: step === 3 ? 'block' : 'none'}}>
                    {UG.lang.template('Step 3: Paste your new dashboard link under your creative content.')}
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./js/host/gift/step-nav.js